import React, { FC } from "react";

import { ImportSteps } from "./ImportSteps";
import { ImportProvider } from "../importContext";

export const Import: FC = () => {
  return (
    <ImportProvider data={{ step: 0 }}>
      <ImportSteps />
    </ImportProvider>
  );
};
